import OverlayCard from './overlay-card';
export default OverlayCard;